import * as THREE from "three";
import { Colors } from "./colors";

export class ColorBufferMaterial extends THREE.MeshStandardMaterial {
  constructor(parameters = {}) {
    super(parameters);

    this.uniforms_ = {
      alpha: { value: 0 },
    };

    this.vertexColors = true;
    this.side = THREE.DoubleSide;
    this.roughness = 0.5;
    this.metalness = 0.4;
  }

  onBeforeCompile(shader) {
    shader.uniforms.alpha = this.uniforms_.alpha;
    shader.vertexShader = `
      attribute vec3 color1;
      attribute vec3 color2;
      uniform float alpha;
      ${shader.vertexShader}
    `;
    shader.vertexShader = shader.vertexShader.replace(
      "#include <color_vertex>",
      `
        vColor = mix(color1, color2, alpha);
      `
    );
    shader.fragmentShader = `
        ${shader.fragmentShader}
      `;
    shader.fragmentShader = shader.fragmentShader.replace(
      "#include <color_fragment>",
      `
      diffuseColor.rgb *= vColor;
      `
    );
  }

  get uniforms() {
    return this.uniforms_;
  }
}

export class ScanBodySelectMaterial extends THREE.MeshStandardMaterial {
  constructor(parameters = {}) {
    super(parameters);

    this.uniforms_ = {
      selectingNarrowScanBodies: { value: 0 },

      scanGaugeSelectedPlaneIndices: { value: new Array(32).fill(-1) },
      scanGaugeSelectedPlanesCount: { value: 0 },
      scanGaugeHighlightedPlaneIndex: { value: -1 },

      narrowScanBodySelectedPlaneIndices: { value: new Array(32).fill(-1) },
      narrowScanBodySelectedPlanesCount: { value: 0 },
      narrowScanBodyHighlightedPlaneIndex: { value: -1 },

      scanGaugeSelectColor: {
        value: new THREE.Color(Colors.primary),
      },
      scanGaugeHighlightColor: {
        value: new THREE.Color(Colors.highlight),
      },
      narrowScanBodySelectColor: {
        value: new THREE.Color(Colors.narrowScanBodySelected),
      },
      narrowScanBodyHighlightColor: {
        value: new THREE.Color(Colors.narrowScanBodyHighlight),
      },
    };

    this.side = THREE.DoubleSide;
    this.color = new THREE.Color(Colors.gray);
    this.roughness = 0.5;
    this.metalness = 0.4;
  }

  onBeforeCompile(shader) {
    shader.uniforms.selectingNarrowScanBodies =
      this.uniforms_.selectingNarrowScanBodies;

    shader.uniforms.scanGaugeSelectedPlaneIndices =
      this.uniforms_.scanGaugeSelectedPlaneIndices;
    shader.uniforms.scanGaugeSelectedPlanesCount =
      this.uniforms_.scanGaugeSelectedPlanesCount;
    shader.uniforms.scanGaugeHighlightedPlaneIndex =
      this.uniforms_.scanGaugeHighlightedPlaneIndex;

    shader.uniforms.narrowScanBodySelectedPlaneIndices =
      this.uniforms_.narrowScanBodySelectedPlaneIndices;
    shader.uniforms.narrowScanBodySelectedPlanesCount =
      this.uniforms_.narrowScanBodySelectedPlanesCount;
    shader.uniforms.narrowScanBodyHighlightedPlaneIndex =
      this.uniforms_.narrowScanBodyHighlightedPlaneIndex;

    shader.uniforms.scanGaugeSelectColor = this.uniforms_.scanGaugeSelectColor;
    shader.uniforms.scanGaugeHighlightColor =
      this.uniforms_.scanGaugeHighlightColor;
    shader.uniforms.narrowScanBodySelectColor =
      this.uniforms_.narrowScanBodySelectColor;
    shader.uniforms.narrowScanBodyHighlightColor =
      this.uniforms_.narrowScanBodyHighlightColor;

    shader.vertexShader = `
      attribute int scanGaugePlaneIndex;
      attribute int narrowScanBodyPlaneIndex;
      flat varying int vSelected;
      flat varying int vHighlighted;
      varying vec3 vSelectColor;
      varying vec3 vHighlightColor;

      uniform int selectingNarrowScanBodies;
      uniform int scanGaugeSelectedPlaneIndices[32];
      uniform int scanGaugeSelectedPlanesCount;
      uniform int scanGaugeHighlightedPlaneIndex;

      uniform int narrowScanBodySelectedPlaneIndices[32];
      uniform int narrowScanBodySelectedPlanesCount;
      uniform int narrowScanBodyHighlightedPlaneIndex;

      uniform vec3 scanGaugeSelectColor;
      uniform vec3 scanGaugeHighlightColor;
      uniform vec3 narrowScanBodySelectColor;
      uniform vec3 narrowScanBodyHighlightColor;
      ${shader.vertexShader}
    `;
    shader.vertexShader = shader.vertexShader.replace(
      "#include <begin_vertex>",
      `
      #include <begin_vertex>
      vSelected = 0;
      vHighlighted = 0;

      vSelectColor = scanGaugeSelectColor;
      vHighlightColor = scanGaugeHighlightColor;

      if (scanGaugePlaneIndex != -1) {
        for (int i = 0; i < scanGaugeSelectedPlanesCount; ++i) {
          if (scanGaugeSelectedPlaneIndices[i] == scanGaugePlaneIndex) {
            vSelected = 1;
            break;
          }
        }

        if (scanGaugePlaneIndex == scanGaugeHighlightedPlaneIndex) {
          vHighlighted = 1;
        }
      }

      if (narrowScanBodyPlaneIndex != -1) {
        for (int i = 0; i < narrowScanBodySelectedPlanesCount; ++i) {
          if (narrowScanBodySelectedPlaneIndices[i] == narrowScanBodyPlaneIndex) {
            vSelected = 1;
            vSelectColor = narrowScanBodySelectColor;
            break;
          }
        }

        if (vSelected == 0 && narrowScanBodyPlaneIndex == narrowScanBodyHighlightedPlaneIndex) {
          vHighlighted = 1;
          vHighlightColor = narrowScanBodyHighlightColor;
        }
      } 
      `
    );
    shader.fragmentShader = `
      flat varying int vSelected;
      flat varying int vHighlighted;
      varying vec3 vSelectColor;
      varying vec3 vHighlightColor;

        ${shader.fragmentShader}
      `;
    shader.fragmentShader = shader.fragmentShader.replace(
      "#include <color_fragment>",
      `
      if (vSelected == 1) {
        diffuseColor.rgb *= vSelectColor;
      }

      if (vHighlighted == 1) {
        diffuseColor.rgb *= vHighlightColor;
      }
      `
    );
  }

  get uniforms() {
    return this.uniforms_;
  }
}
